import React from 'react';

import { CarouselContext } from '../context';

interface Props {
    children: React.ReactNode;
}

class CarouselControls extends React.Component<Props> {
    static contextType = CarouselContext;
    context!: React.ContextType<typeof CarouselContext>;

    render() {
        const { children } = this.props;

        return (
            <div className="carousel__controls">
                {React.Children.map(children, (child) => {
                    if (!React.isValidElement(child)) {
                        return child;
                    }

                    return React.cloneElement(child, this.context);
                })}
            </div>
        );
    }
}

export default CarouselControls;
